import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({ name: 'momentDate' })
export class MomentDatePipe implements PipeTransform {
  transform(value: number, format: string, timezone: string): string | null {
    return moment.unix(value / 1000).tz(timezone)
      .format(format);
  }
}
